'use client'

/**
 * The inline input error a practice surface shows when a grid-in entry can't be
 * graded ("abc", "1,000", a 7-character decimal) — instead of submitting it.
 *
 * Practice used to send such entries straight to the grader, which marked them
 * wrong and recorded a miss (accuracy, mastery, a review card, a Mistake DNA
 * concept gap) for what was a typo. The message comes from `sprEntryProblem`
 * (lib/sat/answer-validation), the same rule the server enforces with a 400,
 * so the two can't disagree. The timed runner has its own live warning.
 *
 * Renders nothing when there is no problem. `role="alert"` so a screen reader
 * hears why Check did nothing; pair the input with `aria-invalid` and
 * `aria-describedby={id}`.
 */
export default function SprEntryError({
  id,
  message,
  className,
}: {
  id: string
  message: string | null
  className?: string
}) {
  if (!message) return null
  return (
    <p
      id={id}
      role="alert"
      className={`text-xs font-medium text-amber-700 dark:text-amber-400 ${className ?? ''}`}
    >
      {message}
    </p>
  )
}
